<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺名称">
                  <el-select v-model="queryForm.vendorId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="系统名称">
                  <el-select v-model="queryForm.vendorSystemId" filterable clearable>
                    <el-option v-for="item in systemList" :label="item.systemName" :value="item.vendorSystemId" :key="item.vendorSystemId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺类型">
                  <el-select v-model="queryForm.vendorType" clearable>
                    <el-option v-for="item in vendorTypeList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="国家">
                  <el-select v-model="queryForm.addressCountryId" filterable clearable>
                    <el-option v-for="item in countryList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="营业状态">
                  <el-select v-model="queryForm.vendorStatus" clearable>
                    <el-option v-for="(value,key) in vendorStatusNumMap" :label="value" :value="key" :key="key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="业务分区">
                  <el-select v-model="queryForm.businessRegionId" filterable clearable>
                    <el-option v-for="item in businessRegionList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-table :data="tableData" @sort-change="onSortChange" v-loading="loading">
      <el-table-column fixed prop="businessRegionName" label="业务分区" width="100"></el-table-column>
      <el-table-column fixed prop="vendorName" label="店铺名称" width="120"></el-table-column>
      <el-table-column prop="name" label="营运状态" width="100">
        <template slot-scope="scope">
          {{ vendorStatusEnumMap[scope.row.vendorStatusEnum] }}
        </template>
      </el-table-column>
      <el-table-column prop="systemName" label="系统名称" width="100"></el-table-column>
      <el-table-column prop="addressCountryName" label="国家" width="100"></el-table-column>
      <el-table-column prop="boutiqueBd" label="商务运营" width="100"></el-table-column>
      <el-table-column prop="boutiqueAssistant" label="运营助理" width="100"></el-table-column>
      <el-table-column label="最新工作日志" width="350" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.workLog">
            {{ scope.row.recordLogUserName }}：{{ scope.row.workLog.substring(0, 59) }}{{scope.row.workLog.length > 60 ? '...':''}}
          </template>
          <div>
            <el-link type="primary" v-if="scope.row.workLog" @click="$router.push({path: '/buyershop/detail?vendorId=' + scope.row.vendorId})">查看历史记录</el-link>
            <el-link class="ml20" type="primary" @click="showForm(scope.row)">记录新日志</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="销售数据" align="center">
        <el-table-column label="本月累计GMV(RMB)" width="190" align="center" prop="1" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.saleInfoData">
              <div class="font-gmv">{{ numberFormat(scope.row.saleInfoData.monthGmv) }}</div>
              <div class="font-sub">上月GMV：{{ numberFormat(scope.row.saleInfoData.lastMonthGmv) }}</div>
              <div class="font-sub">&nbsp;</div>
              <div class="font-sub">&nbsp;</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="本月区域排名" width="160" align="center" prop="2" :sortable="(byVendorType && byBusinessRegion) ? 'custom' : false">
          <template slot-scope="scope">
            <template v-if="scope.row.saleInfoData">
              <div class="font-gmv">{{ scope.row.saleInfoData.regionMonthRanking }}<span class="sub">/{{ scope.row.saleInfoData.regionMonthVendorTotal }}</span></div>
              <div class="font-sub">上月排名：</div>
              <div class="font-sub">{{ scope.row.saleInfoData.regionLastMonthRanking }}/{{ scope.row.saleInfoData.regionMonthVendorTotal }}</div>
              <div class="font-sub">&nbsp;</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="本月平台排名" width="160" align="center" prop="3" :sortable="byVendorType ? 'custom' : false">
          <template slot-scope="scope">
            <template v-if="scope.row.saleInfoData">
              <div class="font-gmv">{{ scope.row.saleInfoData.platformMonthRanking }}<span class="sub">/{{ scope.row.saleInfoData.platformMonthVendorTotal }}</span></div>
              <div class="font-sub">上月排名：</div>
              <div class="font-sub">{{ scope.row.saleInfoData.platformLastMonthRanking }}/{{ scope.row.saleInfoData.platformLastMonthVendorTotal }}</div>
              <div class="font-sub">&nbsp;</div>
            </template>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="货值数据" align="center">
        <el-table-column label="当日货值" width="160" align="center" prop="4" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.productInfoData">
              <div class="font-gmv">{{ numberFormat(scope.row.productInfoData.todayProductValue) }}</div>
              <div class="font-sub">昨日货值：{{ numberFormat(scope.row.productInfoData.yesterdayProductValue) }}</div>
              <div class="font-sub">相比昨日：{{ scope.row.productInfoData.todayProductValueFallRatio }}</div>
              <div class="font-sub">（欧元）</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="当日推新货值" width="160" align="center" prop="5" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.productInfoData">
              <div class="font-gmv">{{ numberFormat(scope.row.productInfoData.todayNewProductValue) }}</div>
              <div class="font-sub">昨日货值：{{ numberFormat(scope.row.productInfoData.yesterdayNewProductValue) }}</div>
              <div class="font-sub">相比昨日：{{ scope.row.productInfoData.todayNewProductValueFallRatio }}</div>
              <div class="font-sub">（欧元）</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="在售商品数" width="160" align="center" prop="6" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.productInfoData">
              <div class="font-gmv">{{ scope.row.productInfoData.onSaleProductTotal }}</div>
              <div class="font-sub">总商品数：{{ scope.row.productInfoData.productTotal }}</div>
              <div class="font-sub">上架率：{{ scope.row.productInfoData.onSaleProductRatio }}%</div>
              <div class="font-sub">&nbsp;</div>
            </template>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="履约数据" align="center">
        <el-table-column label="临期订单数" width="160">
          <template slot-scope="scope">
            <template v-if="scope.row.performInfoData">
              <div class="font-curr">今日到期</div>
              <div class="font-curr">确认订单：{{ scope.row.performInfoData.todayConfirmOrderTotal }}</div>
              <div class="font-curr">发货订单：{{ scope.row.performInfoData.todayShipOrderTotal }}</div>
              <div class="font-sub">2日后到期</div>
              <div class="font-sub">确认订单：{{ scope.row.performInfoData.twodaysConfirmOrderTotal }}</div>
              <div class="font-sub">发货订单：{{ scope.row.performInfoData.twodaysShipOrderTotal }}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="取消/延迟发货" width="200">
          <template slot-scope="scope">
            <template v-if="scope.row.performInfoData">
              <div class="font-curr">昨日违约</div>
              <div class="font-curr">取消订单：{{scope.row.performInfoData.yesterdayCancelOrderTotal}}，{{ scope.row.performInfoData.yesterdayCancelOrderRatio }}%</div>
              <div class="font-curr">延迟发货：{{scope.row.performInfoData.yesterdayDelayOrderTotal}}，{{ scope.row.performInfoData.yesterdayDelayOrderRatio }}%</div>
              <div class="font-sub">上月累计违约</div>
              <div class="font-sub">取消订单：{{scope.row.performInfoData.lastMonthCancelOrderTotal}}，{{ scope.row.performInfoData.lastMonthCancelOrderRatio }}%</div>
              <div class="font-sub">延迟订单：{{scope.row.performInfoData.lastMonthDelayOrderTotal}}，{{ scope.row.performInfoData.lastMonthDelayOrderRatio }}%</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="违约指数" width="160">
          <template slot-scope="scope">
            <template v-if="scope.row.performInfoData">
              <div class="font-curr">当月</div>
              <div class="font-curr">服务指数：{{ scope.row.performInfoData.monthServiceIndexTotal }}%</div>
              <div class="font-curr">违约值：{{ scope.row.performInfoData.monthBreachRatio }}</div>
              <div class="font-sub">上月</div>
              <div class="font-sub">服务指数：{{ scope.row.performInfoData.lastMonthServiceIndexTotal }}%</div>
              <div class="font-sub">违约值：{{ scope.row.performInfoData.lastMonthBreachRatio }}</div>
            </template>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button @click="$router.push({path: '/buyershop/detail?vendorId=' + scope.row.vendorId})" type="text">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.currentPage"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="记录该店日志" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px">
      <el-input type="textarea" v-model="form.content" :rows="10" resize="none" :maxlength="500"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">记录</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVendorList,
  getSystemList,
  getOperationVenderList,
  addVendorLog,
} from "./api";
import {
  getVendorType,
  getCountryList,
  getBusinessRegionList,
} from '../buyershop/api';

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      queryForm: {
        vendorId: null,
        vendorSystemId: null,
        vendorType: null,
        addressCountryId: null,
        vendorStatus: null,
        businessRegionId: null,
        currentPage: 1,
        pageSize: 10,
        sortField: null,
        sortRule: null,
      },
      vendorList: [],
      systemList: [],
      vendorTypeList: [],
      countryList: [],
      businessRegionList: [],
      vendorStatusEnumMap: {
        'PENDING': '准备中',
        'ACTIVE': '营业中',
        'CLOSE': '闭店中',
        'LEAVE': '休假中'
      },
      vendorStatusNumMap: {
        0: '准备中',
        1: '营业中',
        2: '闭店中',
        3: '休假中'
      },
      total: 0,
      tableData: [{}],
      dialogVisible: false,
      form: {
        logCode: 'operation_work_log',
        vendorId: null,
        content: null,
      },
      byVendorType: false,
      byBusinessRegion: false,
    };
  },
  mounted() {
    getVendorList().then(res => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data;
      }
    });
    getSystemList().then(res => {
      if (res.data && res.data.data) {
        this.systemList = res.data.data;
      }
    })
    getVendorType().then(res => {
      this.vendorTypeList = res && res.data && (res.data.data || []).map(item => {
        return {
          value: item.value,
          label: item.desc
        }
      })
    })
    getCountryList().then(res=>{
      this.countryList = res&&res.data&&(res.data.data || []).map(item=>{
        return {
          value:item.addressCountryId,
          label:item.name
        }
      })
    })
    getBusinessRegionList().then(res=>{
      this.businessRegionList = res&&res.data&&(res.data.data || []).map(item=>{
        return {
          value:item.businessRegionId,
          label:item.businessRegionName,
        }
      })
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.currentPage = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorId = null;
      this.queryForm.vendorSystemId = null;
      this.queryForm.vendorType = null;
      this.queryForm.addressCountryId = null;
      this.queryForm.vendorStatus = null;
      this.queryForm.businessRegionId = null;
      this.queryForm.currentPage = 1;
      this.queryForm.sortField = null;
      this.queryForm.sortRule = null;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getOperationVenderList(this.queryForm).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.records;
          this.byVendorType = (this.queryForm.vendorType !== null && this.queryForm.vendorType !== '') ? true : false;
          this.byBusinessRegion = (this.queryForm.businessRegionId !== null && this.queryForm.businessRegionId !== '') ? true : false;
        }
        this.loading = false;
      })
    },
    onSortChange({ column, prop, order }) {
      if (order) {
        this.queryForm.sortField = prop;
        this.queryForm.sortRule = order === 'ascending' ? 2 : 1;
      } else {
        this.queryForm.sortField = null;
        this.queryForm.sortRule = null;
      }
      this.getTableData();
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.queryForm.currentPage = currentPage;
      this.getTableData();
    },
    submit() {
      if (this.repeatSave) {
        return;
      }
      this.repeatSave = true;
      addVendorLog(this.form).then(res => {
        this.repeatSave = false;
        if (res.data.success) {
          this.dialogVisible = false;
          this.$message.success('创建成功');
          this.getTableData();
        } else {
          this.$message.error(res.data.data || res.data.message);
        }
      }).catch((err) => {
        this.repeatSave = false;
      })
    },
    showForm(row) {
      this.form.vendorId = row.vendorId;
      this.form.content = '';
      this.dialogVisible = true;
    },
    numberFormat(val) {
      if (!val) {
        return val;
      }
      if (val > 999999999) {
        return Math.floor(val / 1000000000) + 'b';
      } else if (val > 999999) {
        return Math.floor(val / 1000000) + 'M';
      } else if (val > 9999) {
        return Math.floor(val / 10000) + 'w';
      } else if (val > 999) {
        return Math.floor(val / 1000) + 'k';
      }
      return val;
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.font-gmv {
  font-size: 40px;
  font-weight: bold;
  line-height: 50px;

  .sub {
    font-size: 12px;
    line-height: 18px;
    vertical-align: middle;
  }
}
.font-sub {
  color: #999;
  font-size: 14px;
}
.font-curr {
  font-weight: bold;
}
</style>
